import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getConfig } from '../config.service';

export interface SkomapLocation {
  lon: number;
  lat: number;
  z: number;
}

export interface SecurityZone {
  code: string;
  name: string;
  isAccessible: boolean;
}

export interface RouteSecurityZonesParams {
  routeFrom: SkomapLocation;
  routeTo: SkomapLocation;
}

export interface RouteSecurityZonesResult {
  startSecurityZone: SecurityZone | null;
  destinationSecurityZone: SecurityZone | null;
  otherSecurityZones: SecurityZone[] | null;
}

@Injectable({ providedIn: 'root' })
export class RouteService {
  private http = inject(HttpClient);
  private get baseUrl() { return getConfig().api.middlewareUrl; }

  getRouteSecurityZones(params: RouteSecurityZonesParams): Observable<RouteSecurityZonesResult> {
    return this.http.post<RouteSecurityZonesResult>(
      `${this.baseUrl}/api/securityzones/routeaccessforuser/`,
      params
    );
  }
}
